import createCrud from '../../crud';

export default createCrud({
    resource: 'stages',
    parent: 'yodizproject'
  })